import { VisitCountModel } from 'dibs-visit-tracking';
import { localStorage } from 'dibs-browser-storage';
import SV from 'server-vars';

import isPageType from '../../../utils/isPageType';
import { PAGE_TYPE } from '../../../utils/pageConstants';
import { MODAL_ID, NUM_TIMES_TO_SHOW, NUM_VISITS_TO_SHOW } from './constants';

/**
 * Handles checking Local Storage to see if the criteria for the user
 * having seen the modal has been met.
 * @return {boolean}
 */
function hasSeenModal() {
    if (localStorage) {
        const modalStorage = localStorage.getItem(MODAL_ID);
        if (modalStorage) {
            const { viewedThisSession, totalViewCount } = modalStorage;
            return viewedThisSession || totalViewCount >= NUM_TIMES_TO_SHOW;
        }
    }
    return false;
}

/**
 * The Notification Queue Rule. Returns Promise(true) if the Collaborative
 * Purchasing Modal should be shown. Returns Promise(false) otherwise.
 * @return {Promise<boolean>}
 */
export default function collaborativePurchasingRule() {
    const isUserTypeTrade = SV.get('settings.isUserTypeTrade') || false;
    const isBlacklistedPage = isPageType([
        PAGE_TYPE.CHECKOUT,
        PAGE_TYPE.CHECKOUT_CONFIRMATION,
        PAGE_TYPE.ORDER_MANAGER,
    ]);

    if (!isUserTypeTrade || isBlacklistedPage || hasSeenModal()) {
        return Promise.resolve(false);
    }

    const visitTracking = new VisitCountModel();
    return Promise.resolve(visitTracking.get('session') >= NUM_VISITS_TO_SHOW);
}
